import React, {useEffect, useState} from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import {
  Form,
  Segment,
  Loader,
  Dimmer,
  Image, Container
} from "semantic-ui-react";
import "./col-main.module.css";
import styles from "./col-main.module.css";

import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import BillList from "./BillList";

import {
    FETCH_CORPORATIONS_FULFILLED,
    FETCH_CORPORATIONS_REJECTED,
} from "../actions/corporations";

import Navigation from "./navigation";
import axios from "axios";
import {API_BASE} from "../config/env";
import CaptchaV2 from "./CaptchaV2";
import Helper from './Helper';
import Header from "./Header";
import Footer from "./Footer";



function Main(props) {
    Main.propTypes = {
        corporations: PropTypes.object,
        invoices: PropTypes.object,
    };

    const [corporations, setCorporations] = useState([]);
    const [selectedCorp, setSelectedCorp] = useState([]);
    const [subscriberNo, setSubscriberNo] = useState("");
    const [invoiceList, setInvoiceList] = useState(null);
    const [errors, setErrors] = useState({});
    const [fetchingCoprs, setFetchingCorps] = useState(false);
    const [fetchingBills, setFetchingBills] = useState(false);
    const [messageOpen, setMessageOpen] = useState(false);
    const [serviceMessage, setServiceMessage] = useState("");
    const [selectedSector, setSelectedSector] = useState("");
    const [renderRequiredFields, setRenderRequiredFiled] = useState(false);
    const [subscriberNo1, setSubscriberNo1] = useState("");
    const [subscriberNo2, setSubscriberNo2] = useState("");
    const [subscriberNo3, setSubscriberNo3] = useState("");

    const [captchaEnable, setCaptchaEnable] = useState(false);
    const [captchaStr, setCaptchaStr] = useState('');
    const [captchaParam, setCaptchaParam] = useState(false);
    const [captchaIdentifier, setCaptchaIdentifier] = useState('');
    const [captchaData, setCaptchaData] = useState('');
    const [mainImage ,  setMainImage] = useState([]);
    const {setUiParams,getButtonStyle , getTrackingId , getStorageItem ,checkSession,isExternalSdk} = Helper();


    useEffect(async () => {
        await fetchCorporations();
        getCorpList();
        await getCaptcha();
        setCaptchaParam(await fetchCaptchaParam())
    }, []);

    const fetchCaptchaParam = async () => {
        const param ='KFO_SDK_CAPTCHA_ENABLE'
        const result = await fetchParam(param);
        if (result.data) {
            let captchaParam = result.data.parameterValue == '1' ? true : false
            return captchaParam
        }
    };

    const fetchParam = async (param) => {
        const reqParam = {
            paramName: param,
        };
        try {
            const response = await axios.post(`${API_BASE}/getParam`,reqParam,{
                headers: {
                    'Content-Type': 'application/json'
                }
            }).catch((error) => console.log(error));
            if (response.status === 200) {
                // response -    object, eg { status: 200, message: 'OK' }
                return response;
            }

            return false;
        } catch (error) {
            return error;
        }
    };


    const fetchCorporations = async () => {
      try {
        setFetchingCorps(true);
        const result = await fetchCorporationsAsync();
        await checkSession(result.payload.data.operationResult);
        await setUiParams(result);
        setMainImage(getStorageItem("main"));
        setCorporations(result.payload.data.corporationList);
        setFetchingCorps(false);
      }
      catch (error){
        setFetchingCorps(false);
      }
    };

    const fetchCorporationsAsync = async () => {
        try {
            const response = await axios.get(`${API_BASE}/getUiParams/` + getTrackingId());
            if (response.status === 200) {
                return {
                    type: FETCH_CORPORATIONS_FULFILLED,
                    payload: response,
                };
            }
        } catch (error) {
            return {
                type: FETCH_CORPORATIONS_REJECTED,
                payload: error,
            };
        }
    };

    const changeSelectedSector = (sector) => {
        if (selectedSector === sector) {
            setSelectedSector("");
        } else {
            setSelectedSector(sector);
            setSelectedCorp('');
            setRenderRequiredFiled(false);
            setCaptchaEnable(false);
        }
    };

    const getCorpList = () => {
        if (corporations) {
            if (selectedSector && selectedSector !== "") {
                var newList = corporations.filter(function (corp) {
                    return corp.sector.toLowerCase() === selectedSector.toLowerCase();
                });


                return newList.map((data) => ({
                    label: data.corpName,
                    value: data.corpCode,
                    sector: data.sector,
                    requiredFields: data.invoiceRequiredFields
                }));
            } else {
                return corporations.map((data) => ({
                    label: data.corpName,
                    value: data.corpCode,
                    sector: data.sector,
                    requiredFields: data.invoiceRequiredFields
                }));
            }
        }
    };



    const getCorpListForMain = () => {
        if (corporations) {
            return corporations.map((data) => ({
                label: data.corpName,
                value: data.corpCode,
                sector: data.sector,
                requiredFields: data.invoiceRequiredFields
            }));
        }
    };

    const onsubmit = async (e) => {
        setFetchingBills(true);
        setInvoiceList(null)
        try {
            const errorsFromValidate = await validate();
            if (Object.keys(errorsFromValidate).length === 0) {
                const invoiceList = await fetchInvoices(selectedCorp, subscriberNo, subscriberNo1, subscriberNo2,
                    subscriberNo3,captchaStr,captchaIdentifier);
                setInvoiceList(invoiceList);
                await getCaptcha();
            }
        } catch (e) {
            setFetchingBills(false);
        }
        setFetchingBills(false);
        e.preventDefault();
    };

    function compare_custPayMethod( a, b )
    {
        if ( a.custPaymentMethod.toLowerCase() < b.custPaymentMethod.toLowerCase()){
            return -1;
        }
        if ( a.custPaymentMethod.toLowerCase() > b.custPaymentMethod.toLowerCase()){
            return 1;
        }
        return 0;
    }

    const fetchInvoices = async (selectedCorpFromFunc, subscriberNo, subscriberNoFromFunc1, subscriberNoFromFunc2,
                                 subscriberNoFromFunc3, captchaText, captchaIdentifier) => {
        let databody = {
            corpCode: selectedCorpFromFunc.value,
            subscriberNo: subscriberNo,
            subsDesc1: subscriberNoFromFunc1,
            subsDesc2: subscriberNoFromFunc2,
            subsDesc3: subscriberNoFromFunc3,
            captchaText: captchaText,
            captchaIdentifier: captchaIdentifier,
            trackingId:getTrackingId()
        };
        try {
            const response = await axios
                .post(`${API_BASE}/inquireInvoice`, databody)
                .catch((error) => console.log(error));
            if (response.status === 200) {
                await checkSession(response.data.operationResult)
                // response -    object, eg { status: 200, message: 'OK' }
                if (response.data.operationResult.resultCode === "0") {
                    const invoiceList = getInvoiceList(response.data);
                    return invoiceList;
                } else {
                    setServiceMessage(response.data.operationResult.resultDesc);
                    setMessageOpen(true);
                }
            }
            return false;
        } catch (err) {
            console.error(err);
            return false;
        }
    };

    const getInvoiceList = (invoiceResponse) => {
        if (invoiceResponse.invoiceList.length > 0) {
            const corpAndSubscriberInfo = invoiceResponse.corpAndSubscriberInfo;

            /* anasayfa da  borc listelenirken taksitsiz secenege gore gosterim yapilacak.
                o yuzden  taksit olmayan commisyon filtreleniyor.
             */
            let custPaymentMethod ;
            if(isExternalSdk()){
                custPaymentMethod = "SDK_CC";
            }
            else{
                custPaymentMethod = "THREE_D_SESSION_ID";
            }
            const invoiceList = invoiceResponse.invoiceList.map((invoice) =>
                invoice.commissionList
                    .sort(compare_custPayMethod)
                    .filter((com) => ((com.custPaymentMethod === custPaymentMethod))
                        && invoice.invoiceAmount != '0')
                    .map((commission) => ({
                        corpCode: corpAndSubscriberInfo.corpCode,
                        corpName: corpAndSubscriberInfo.corpName,
                        currency: corpAndSubscriberInfo.currency,
                        subscriberNo: corpAndSubscriberInfo.subscriberNo,
                        subscriberName: corpAndSubscriberInfo.subscriberName,
                        isDonationDo: corpAndSubscriberInfo.isDonationDo,
                        vendorDonatId: corpAndSubscriberInfo.vendorDonatId,
                        invoiceDueDate: invoice.invoiceDueDate,
                        formattedInvoiceDueDate: invoice.formattedInvoiceDueDate,
                        invoiceAmount: invoice.invoiceAmount,
                        bankRefNo: invoice.bankRefNo,
                        invoiceInfo1: invoice.invoiceInfo1,
                        invoiceInfo2: invoice.invoiceInfo2,
                        invoiceInfo3: invoice.invoiceInfo3,
                        invoiceNo: invoice.invoiceNo,
                        invoiceRefNo: invoice.invoiceRefNo,
                        invoiceSeqNo: invoice.invoiceSeqNo,
                        invoiceStatus: invoice.invoiceStatus,
                        newInstallmentAmount: invoice.newInstallmentAmount,
                        commissionAmount: commission.commissionAmount,
                        totalAmount: commission.totalAmount,
                        commissionList: invoice.commissionList,
                        customerPaymentMethod: custPaymentMethod,
                        installmentCount: 0
                    }))
            );
            return concatAll(invoiceList);
        } else return null;
    };

    const concatAll = (lists) => {
        var sonuc = [];
        lists.forEach((iceridekiDizi) => sonuc.push.apply(sonuc, iceridekiDizi));
        return sonuc;
    };

    const validate = async () => {
        const errors = {};
        if (!selectedCorp || selectedCorp === "" || selectedCorp.length == 0) {
            errors.selectedCorp = "Kurum seçiniz";
            setServiceMessage(errors.selectedCorp);
            setMessageOpen(true);
        } else if (captchaEnable && (captchaStr === '' || captchaStr.trim() === '')) {
            setCaptchaStr('');
            errors.captcha = "Resimdeki karakterleri giriniz.";
            setServiceMessage(errors.captcha);
            setMessageOpen(true);
        } else{
            selectedCorp.requiredFields.map((field, i) => {
                    if (i == 0) {
                        if (!subscriberNo) {
                            errors.subscriberNo = field.label + " boş olamaz.";
                            setServiceMessage(errors.subscriberNo);
                            setMessageOpen(true);
                        }
                        return errors;
                    } else if (i == 1) {
                        if (!subscriberNo1) {
                            errors.subscriberNo1 = field.label + " boş olamaz.";
                            setServiceMessage(errors.subscriberNo1);
                            setMessageOpen(true);
                        }
                        return errors;
                    } else if (i == 2) {
                        if (!subscriberNo2) {
                            errors.subscriberNo2 = field.label + " boş olamaz.";
                            setServiceMessage(errors.subscriberNo2);
                            setMessageOpen(true);
                        }
                        return errors;
                    } else if (i == 3) {
                        if (!subscriberNo3) {
                            errors.subscriberNo3 = field.label + " boş olamaz.";
                            setServiceMessage(errors.subscriberNo3);
                            setMessageOpen(true);
                        }
                        return errors;
                    }
                }
            )
        }
        setErrors(errors);
        return errors;
    };

    const selectedCorpChange = (selected) => {
        if (selected) {
            setSelectedSector(selected.sector);
            setRenderRequiredFiled(true);
            if (captchaParam) {
                setCaptchaEnable(true)
                if (document.getElementById('reload_href') != null){
                    setCaptchaStr('');
                    document.getElementById('reload_href').click();
                }
            }
        }
        if (selected === null) {
            setRenderRequiredFiled(false);
            setCaptchaEnable(false)
        }
        setSelectedCorp(selected);
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setMessageOpen(false);
    };

    const handleRequiredField = (e, id) => {
        const {value} = e.target;
        if (id == 0) {
            setSubscriberNo(value);
        }
        if (id == 1) {
            setSubscriberNo1(value);
        }
        if (id == 2) {
            setSubscriberNo2(value);
        }
        if (id == 3) {
            setSubscriberNo3(value);
        }
    };

    const getCaptcha = async () => {
        const result = await callCaptcha();
        if (typeof result != "undefined" && result != false){
            setCaptchaStr('');
            setCaptchaData(result.data.image);
            setCaptchaIdentifier(result.data.identifier);
        }
    };

    const callCaptcha = async () => {
        try {
            const response = await axios
                .post(`${API_BASE}/getCaptcha/`+getTrackingId())
                .catch((errors) => console.log(errors));
            if (response.status === 200) {
                // response - object, eg { status: 200, message: 'OK' }
                return response
            }
            return false
        } catch (err) {
            console.error(err)
            return false
        }
    }

    const handleChangeCaptchaStr = (event) => {
        setCaptchaStr(event.target.value.toUpperCase());
    };


    return (
      <div>
        <Dimmer active={fetchingCoprs} inverted>
          <Loader inverted>Sayfa Oluşturuluyor</Loader>
        </Dimmer>

        {
          !fetchingCoprs &&
          <Header className='header' />
        }
        {
          !fetchingCoprs &&
          <Container className='mainContainer'>
              <div>
                <div>
                    <div className={styles.drop}>
                        <label className={styles.label}> Hızlı Arama </label>
                        <Select

                            isClearable
                            isSearchable
                            id="selectedCorp"
                            name="selectedCorp"
                            placeholder="Kurum"
                            options={getCorpListForMain()}
                            value={selectedCorp}
                            onChange={selectedCorpChange}
                        />
                    </div>
                    <div>
                        <Navigation
                            selected={selectedSector}
                            changeCorpSector={changeSelectedSector}
                        />
                    </div>
                </div>
                <div>
                    <Form onSubmit={onsubmit} loading={false} className={styles.mainForm}>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <Select
                                    className={styles.kurumDrop}
                                    isClearable
                                    id="selectedCorp"
                                    name="selectedCorp"
                                    placeholder="Kurum"
                                    options={getCorpList()}
                                    value={selectedCorp}
                                    onChange={selectedCorpChange}
                                />
                            </Form.Field>
                            {renderRequiredFields == true ? (
                                    selectedCorp.requiredFields ? (selectedCorp.requiredFields.map((field, i) => (<Form.Field>
                                        <Form.Input
                                            name={'subscriberNo' + field.orderNo}
                                            id={field.orderNo}
                                            onChange={(e) => handleRequiredField(e, i)}
                                            placeholder={field.label}
                                            maxLength={field.maxLength}
                                        />
                                    </Form.Field>))) : (<h1></h1>)
                                ) :
                                (
                                    <h1></h1>
                                )

                            }
                            {captchaEnable == true ? (
                                <Form.Field className={styles.captcha}>
                                    <CaptchaV2 data={captchaData} onChangeValue={handleChangeCaptchaStr}
                                           captchaChars={captchaStr}
                                            refreshCaptcha={getCaptcha}  />
                                </Form.Field>) : (<h1></h1>)

                            }

                            {renderRequiredFields == true ? (<Form.Field>
                                <button className={styles.button} style= {getButtonStyle()}>Sorgula</button>
                            </Form.Field>) : (<h1></h1>)
                            }

                        </Form.Group>
                    </Form>
                </div>
                <Segment basic textAlign="center">

                    <Dimmer active={fetchingBills} inverted>
                        <Loader inverted>Faturalar Sorgulanıyor...</Loader>
                    </Dimmer>

                    <BillList billList={invoiceList}/>

                    <Snackbar
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        open={messageOpen}
                        autoHideDuration={6000}
                        onClose={handleClose}
                        message={serviceMessage}
                        action={
                            <React.Fragment>
                                <IconButton
                                    size="small"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={handleClose}>
                                    <CloseIcon fontSize="small"/>
                                </IconButton>
                            </React.Fragment>
                        }
                    />
                </Segment>
                {
                  !fetchingCoprs  && mainImage &&
                  <a href={mainImage.toUrl} target='_blank'>
                     <Image src={`data:image/jpeg;base64,${mainImage.image}`} className={styles.imageContainer}/>
                  </a>
                }
              </div>
            </Container>
          }
          {
            !fetchingCoprs && !isExternalSdk() &&
            <div style={{position:"fixed",bottom:0,width:'100%'}}>
              <Segment inverted vertical>
                <Footer/>
              </Segment>
            </div>
          }
      </div>
    );
}

export default Main;
